import { interval } from 'rxjs';
import { filter, map, switchMap, takeUntil, withLatestFrom } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { JobStatus } from '../markout.constant';
import { MarkoutAction } from '../markout.action';
import { IBasicReportView, IMarkoutStoreSegment } from '../markout.interface';
import { getLatestJob } from '../_helpers/getLatestJob';

const POLL_INTERVAL_MS = 5000;

const hasActiveJob = (reports: IBasicReportView[]): boolean => reports.some((report) => {
  const latestJob = getLatestJob(report);
  if (latestJob === null) {
    return false;
  }
  return latestJob.status === JobStatus.Pending || latestJob.status === JobStatus.InProcess;
});

export const pollReportsEpic: IEpic<IMarkoutStoreSegment> = (action$, state$) => action$.pipe(
  isTypeOf(MarkoutAction.startReportsPolling),
  switchMap(() => interval(POLL_INTERVAL_MS).pipe(
    takeUntil(action$.pipe(isTypeOf(MarkoutAction.stopReportsPolling))),
    withLatestFrom(state$),
    filter(([, state]) => hasActiveJob(state.markout.reports)),
    map(() => MarkoutAction.reloadReportList()),
  )),
);
